import { Divider, Container, Typography, Grid } from "@material-ui/core";
import Layout from "../../../components/Layout";
import CardCourseList from "../../../components/CardCourseList";
import { Translator } from "@itarget/shared";

import Pagination from '@material-ui/lab/Pagination'; 
import { useState } from "react";

const MyCourseView = ({ selectCourse, course, paginationObject, handlePaginate }) => {
  course = paginationObject?.data || course
  let lastPage = paginationObject?.last_page || '1'
  let currentPage = paginationObject?.current_page || '1'

  const handlePageChange = async (event, value) => {
    if(handlePaginate){
      handlePaginate(value)
    }
  };

  return (
    <Layout>
      <Container className="myActivities-header title-page">
        <Typography variant="h4"><Translator transRef={`translation.MEUS CURSOS`} /></Typography>
      </Container>
      <Divider />
      <Container maxWidth='xl'>
        {(!course || course.length === 0) && (
          <Typography variant="h6"><Translator transRef={`translation.Nenhum registro encontrado`} /></Typography>
        )}
        {course?.map((row) => (
          <CardCourseList selectCourse={selectCourse} course={row} />
        ))}
      </Container>

      <Grid container justify="center" style={{ marginTop: '20px' }}>
        <Pagination
          count={lastPage}
          page={currentPage}
          onChange={handlePageChange}
          variant="outlined"
          shape="rounded"
        />
      </Grid>

    </Layout>
  );
};

export default MyCourseView;
